/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_W3Inputs */

const en_mk_cmp_linear_w3 = /** @type {(inputs: Mk_Cmp_Linear_W3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maturity matters more to you than built-in team chat or approvals.`)
};

const id_mk_cmp_linear_w3 = /** @type {(inputs: Mk_Cmp_Linear_W3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kematangan produk lebih penting bagi Anda daripada chat tim atau approval bawaan.`)
};

/**
* | output |
* | --- |
* | "Maturity matters more to you than built-in team chat or approvals." |
*
* @param {Mk_Cmp_Linear_W3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_w3 = /** @type {((inputs?: Mk_Cmp_Linear_W3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_W3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_w3(inputs)
	return en_mk_cmp_linear_w3(inputs)
});